module.exports = __webpack_public_path__ + "img/customer_04.a4fcf963.jpg";